import { beginLoading, endLoading } from "../../../ducks/loadingSpinner";
import { SURVEY_FUNDING_AREA, SURVEY_NAME, SURVEY_PROGRAM } from "../../../ducks/survey";
import { PREDEFINED_LIST, PREDEFINED_LIST_TYPE } from "../../../ducks/surveyEditor";
import { READ_ONLY, READ_ONLY_BY_PERMISSIONS } from "../../../ducks/surveyRunner";
import {
  addQuestionAnswer,
  addRow,
  deleteRow,
  deleteRows,
  downloadCSVTemplate,
  downloadFile,
  EDITING_DISABLED,
  importRows,
  jumpToPage,
  loadPreviousPeriodQuestionAnswers,
  OTHER_ANSWER_ID,
  QUESTION_VALIDATIONS,
  removeQuestionAnswer,
  reorderQuestionRow,
  selectFiles,
  setQuestionAnswer,
  SHOW_OVERVIEW_MENU,
  showHideOverview,
  SURVEY_CURRENT_PAGE,
  SURVEY_RESULT,
  TRIGGER_STATE,
  uploadFiles,
  validateQuestionAnswer
} from "../../../ducks/surveyView";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { loadPredefinedList } from "../../../ducks/surveyEditorActions";
import SurveyView from "./SurveyView";

const mapStateToProps = (state) => {
  return {
    surveyCurrentPage: state.surveyView[SURVEY_CURRENT_PAGE],
    showOverviewMenu: state.surveyView[SHOW_OVERVIEW_MENU],
    surveyResult: state.surveyView[SURVEY_RESULT],
    questionValidations: state.surveyView[QUESTION_VALIDATIONS],
    surveyName: state.survey[SURVEY_NAME],
    surveyFundingArea: state.survey[SURVEY_FUNDING_AREA],
    surveyProgram: state.survey[SURVEY_PROGRAM],
    triggerState: state.surveyView[TRIGGER_STATE],
    OtherAnswer: state.surveyView[OTHER_ANSWER_ID],
    predefinedList: state.surveyEditor[PREDEFINED_LIST],
    predefinedListType: state.surveyEditor[PREDEFINED_LIST_TYPE],
    readonly: state.surveyRunner[READ_ONLY],
    readOnlyByPermissions: state.surveyRunner[READ_ONLY_BY_PERMISSIONS],
    editingDisabled: state.surveyView[EDITING_DISABLED]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      jumpToPage,
      showHideOverview,
      setQuestionAnswer,
      addQuestionAnswer,
      removeQuestionAnswer,
      addRow,
      importRows,
      deleteRow,
      deleteRows,
      loadPreviousPeriodQuestionAnswers,
      downloadCSVTemplate,
      uploadFiles,
      downloadFile,
      selectFiles,
      loadPredefinedList,
      reorderQuestionRow,
      endLoading,
      beginLoading,
      validateQuestionAnswer
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyView);
